import { render, staticRenderFns } from "./ExamEdith.vue?vue&type=template&id=7cbfa326&lang=pug&"
import script from "./ExamEdith.vue?vue&type=script&lang=js&"
export * from "./ExamEdith.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports